import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier, pluralSizeClassName, } from "../modifiers/index.js";
export const Tags = ({ children, className, hasAddons, size, ...props }) => {
    const _class = classNames("tags", pluralSizeClassName(size), modifier({ hasAddons }), className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
